<template>
  <div style="margin-left: 87px;">
    <span style="color:red">*</span>
    {{$t("crs36.luckyRedPacket.condition")}}
  <el-select v-model="update.col.data.type" placeholder="请选择" :label="$t('crs36.luckyRedPacket.condition')" >
    <el-option v-if="update.col.optionList && !(update.col.optionList instanceof Array)" v-for="(value,key) in update.col.optionList" :label="value" :value="update.col.isNumber?Number(key):key"></el-option>
  </el-select>
    {{$t("crs36.luckyRedPacket.get")}}
    <el-input-number  v-model="update.col.data.result" :min="1" />
    {{$t("crs36.luckyRedPacket.redPacket")}}
  </div>
</template>

<script>
    import URL from "@/views/crs36/util/url"
  export default {
    name: 'conditionDto',
    props:["update"],
      data () {
          return {

          }
      },
    methods: {

    },
  }
</script>
